import { style } from '@angular/animations';
import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'ngx-button-comp-menu',
  template: `
  <div ngbDropdown container="body" >
      <span style="cursor:pointer;text-decoration: underline;" ngbDropdownToggle id="dropdownBasic1"> Mais ações <i style="cursor:pointer;" class="fas fa-ellipsis-h"></i> </span>
      <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
        <button style="cursor:pointer;" (click)="onClick('CLONE')" ngbDropdownItem>Clonar pesquisa</button>
        <button style="cursor:pointer;" (click)="onClick('CLEAN')" ngbDropdownItem>Limpar respostas</button>
        <button style="cursor:pointer;" placement="left" [ngbTooltip]="getLabel()" [disabled]="rowData.status !== 'RUNNING'"
        (click)="onClick('NOTIFY')" ngbDropdownItem>Notificar usuários</button>
      </div>
    </div>
  `,
  styles: [`
    .dropdown-toggle::after {
      display:none;
    }

    .dropdown-item:active {
      color: #fff;
      text-decoration: none;
      background-color: #006b9c;
    }
  `]
})

// <button style="cursor:pointer;" (click)="onClick('CLONE')" ngbDropdownItem>Clonar pesquisa</button>


export class CustomMenuComponent implements OnInit {
  @Input() rowData: any;

  @Output() save: EventEmitter<any> = new EventEmitter();


  ngOnInit() {

  }


  getLabel() {
    if (this.rowData.status !== 'RUNNING') {
      return 'Somente pesquisas que estão rodando podem notificar usuários';
    }
  }

  onClick(context) {
    if (context === 'NOTIFY') {
      if (this.rowData.status !== 'RUNNING') {
        return;
      }
    }

    this.rowData.context = context;
    this.save.emit(this.rowData);
  }
}
